export const TYPE_STRING = 'string';
export const TYPE_INTEGER = 'integer';
export const TYPE_NUMBER = 'number';
export const TYPE_BOOLEAN = 'boolean';
export const TYPE_ARRAY = 'array';
export const TYPE_OBJECT = 'object';
